<template lang="html">
  <div ref="onboarding-box" class="row no-margin start-xs">
    <div
      :class="step_to_show.classes"
      class="onboarding"
      v-show="show_onboarding"
    >
      <span v-html="step_to_show.description"></span>
      <strong class="capitalize">
        {{
          step_to_show.domID === 'onboarding-class-dropdown'
            ? getCourseDetail.title
            : null
        }}
      </strong>
      <div
        @click="changeStep(step_to_show)"
        style="font-weight: bolder"
        class="ok-button end-xs"
      >
        OK
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import updateUser from 'services/account/updateUser';
  import findIndex from 'lodash/findIndex';
  import { EventBus } from 'utils/event-bus';
  import courseNavigationSteps from './courseNavigationSteps';
  import createRoundtableSteps from './createRoundtableSteps';
  import createLiveDiscussionSteps from './createLiveDiscussionSteps';

  export default {
    data() {
      return {
        show_onboarding: false,
        course_navigation_steps: this.deepClone(courseNavigationSteps),
        create_roundtable_steps: this.deepClone(createRoundtableSteps),
        create_live_discussion_steps: this.deepClone(createLiveDiscussionSteps),
        steps: [],
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourseDetail', 'getOnboarding']),
      step_collections() {
        return [
          this.course_navigation_steps,
          this.create_roundtable_steps,
          this.create_live_discussion_steps,
        ];
      },
      step_collection_to_use() {
        if (!this.getOnboarding.course_navigation) {
          return {
            steps: this.course_navigation_steps,
            title: 'course_navigation',
          };
        }
        if (!this.getOnboarding.create_roundtable) {
          return {
            steps: this.create_roundtable_steps,
            title: 'create_roundtable',
          };
        }
        if (!this.getOnboarding.create_live_discussion) {
          return {
            steps: this.create_live_discussion_steps,
            title: 'create_live_discussion',
          };
        }
        return {
          steps: [],
          title: '',
        };
      },
      step_to_show() {
        const steps = this.steps.filter((step) => step && !step.seen);
        return (
          steps[0] || {
            id: null,
            description: '',
            seen: false,
            domID: '',
            classes: [{ 'display-none': true }],
          }
        );
      },
    },
    methods: {
      deepClone(array) {
        return JSON.parse(JSON.stringify(array));
      },
      appendOnboardingBox() {
        const target = document.getElementById(this.step_to_show.domID);
        if (target) {
          this.show_onboarding = true;
          target.classList.add('onboarding-relative');
          target.appendChild(this.$refs['onboarding-box']);
        } else {
          this.show_onboarding = false;
        }
      },
      // if God is good to us, She will allow us the time to refactor the way we progress through steps
      changeStep(step) {
        // get step to update
        const index = step ? findIndex(this.steps, { id: step.id }) : null;
        const stepToUpdate = this.steps[index];
        if (stepToUpdate) {
          stepToUpdate.seen = true;
          // need to replace using splice to maintain reactivity
          this.steps.splice(index, 1, stepToUpdate);
          // find next in list
          const nextOnboardElement = document.getElementById(
            this.step_to_show.domID
          );
          const lastStep = step === this.steps[this.steps.length - 1];
          if (nextOnboardElement && !lastStep) {
            nextOnboardElement.classList.add('onboarding-relative');
            nextOnboardElement.appendChild(this.$refs['onboarding-box']);
          } else {
            this.removeOnboardingRelativeClass(step.domID);
            this.finishOnboarding();
            this.show_onboarding = false;
          }
          // Each step adds a class that ensures position: relative on the index dom element
          // We should also remove this class for the previous step so that it does not affect other css rules
          if (index > 0) {
            this.removeOnboardingRelativeClass(this.steps[index - 1].domID);
          }
        }
      },
      removeOnboardingRelativeClass(previousDomID) {
        const previousOnboardElement = document.getElementById(previousDomID);
        if (previousOnboardElement) {
          previousOnboardElement.classList.remove('onboarding-relative');
        }
      },
      finishOnboarding() {
        // if statement is precautionary because we dont want to update db with
        // empty onboarding key- it may trigger an infinite loop if onboarding
        // is continually updated. However if things are happening correctly,
        // title should not be falsey.
        if (this.step_collection_to_use.title) {
          const newOnboarding = { ...this.getOnboarding };
          newOnboarding[this.step_collection_to_use.title] = true;
          updateUser(this.getProfile.id, { onboarding: newOnboarding })
            .then((res) => {
              this.$store.dispatch('updateOnboarding', res.data.onboarding);
            })
            .catch(console.error);
        }
      },
      // handy function for debugging purposes
      // undoOnboarding() {
      //   const newOnboarding = { ...this.getOnboarding };
      //   newOnboarding.course_navigation = false;
      //   newOnboarding.create_roundtable = false;
      //   updateUser(this.getProfile.id, { onboarding: newOnboarding })
      //     .then((res) => {
      //       this.$store.dispatch('updateOnboarding', res.data.onboarding);
      //     })
      //     .catch(console.error);
      // },
    },
    mounted() {
      this.steps = this.step_collection_to_use.steps;
      if (this.step_collection_to_use.steps.length) {
        this.steps = this.step_collection_to_use.steps;
        this.show_onboarding = true;
        this.$nextTick(() => {
          this.appendOnboardingBox();
        });
      }
      this.unwatchStepCollectionToUse = this.$watch(
        'step_collection_to_use',
        (collection) => {
          this.steps = collection.steps;
          this.show_onboarding = Boolean(collection.title);
          this.show_onboarding = true;
          this.$nextTick(() => {
            this.appendOnboardingBox();
          });
        }
      );
      // resume onboarding when roundtable settings bar is mounted
      EventBus.$on('roundtable-title-mounted', () => {
        const element = document.getElementById(
          'onboarding-edit-roundtable-title'
        );
        if (
          element &&
          this.step_to_show.domID === 'onboarding-edit-roundtable-title'
        ) {
          this.show_onboarding = true;
          this.$nextTick(() => {
            this.appendOnboardingBox();
          });
        }
      });
      // resume onboarding when online student add student button is mounted
      EventBus.$on('online-add-student-button-appears', () => {
        const element = document.getElementById('onboarding-add-students');
        if (element && this.step_to_show.domID === 'onboarding-add-students') {
          this.show_onboarding = true;
          this.$nextTick(() => {
            element.classList.add('onboarding-relative');
            element.appendChild(this.$refs['onboarding-box']);
          });
        }
      });
    },
    beforeDestroy() {
      // this.undoOnboarding();
      EventBus.$off('roundtable-title-mounted');
      EventBus.$off('online-add-student-button-appears');
      this.unwatchStepCollectionToUse();
      this.step_collections.forEach((collection) => {
        collection.forEach((step) => {
          const element = document.getElementById(step.domID);
          if (element) {
            element.classList.remove('onboarding-relative');
          }
        });
      });
    },
  };
</script>
<!-- needs to be global class -->
<!-- the div that is holding the onboarding step needs to be relative so the class needs to be global -->
<style lang="css">
  .onboarding-relative {
    position: relative;
  }
</style>
<style scoped lang="stylus">
  .onboarding
    color: white;
    font-size: 16px;
    font-weight: 500;
  .display-none
    display: none;
  .onboarding-bottom-shift-left
    position: absolute;
    width: 240px;
    bottom: initial;
    background-color: #283248;
    z-index: 1;
    padding: 15px 20px;
    color: white;
    &:before
      content: '';
      position: absolute;
      top: -30px;
      left: 20%;
      z-index: 1;
      transform: translate(-50%, 0);
      border: solid 15px transparent;
      border-bottom-color: #283248;
  .onboarding-bottom
    position: absolute;
    width: 230px;
    left: 50%;
    background-color: #283248;
    transform: translate(-50%, 0);
    z-index: 10;
    padding: 15px 20px;
    color: white;
    &:before
      content: '';
      position: absolute;
      top: -30px;
      left: 50%;
      z-index: 10;
      transform: translate(-50%, 0);
      border: solid 15px transparent;
      border-bottom-color: #283248;

  .onboarding-new-rt-button
    z-index: 10;
    position: absolute;
    background-color: #283248;
    padding: 15px 20px;
    width: 100%;
    top: 60px;
    left: 0px;
    color: white;
    &:before
      content: '';
      position: absolute;
      top: -30px;
      left: 92%;
      z-index: 10;
      transform: translate(-50%, 0);
      border: solid 15px transparent;
      border-bottom-color: #283248;

  .onboarding-edit-title
    position: fixed;
    top: 110px;
    left: 270px;
    width: 240px;
    background-color: #283248;
    z-index: 1;
    padding: 15px 20px;
    color: white;
    &:before
      content: '';
      position: absolute;
      top: -30px;
      left: 20%;
      z-index: 1;
      transform: translate(-50%, 0);
      border: solid 15px transparent;
      border-bottom-color: #283248;

  .onboarding-roundtable-settings-bar
    margin-top: 20px;

  .onboarding-right-side
    position: absolute;
    width: 250px;
    bottom: initial;
    left: 50%;
    background-color: #283248;
    transform: translate(-50%, 0);
    z-index: 1;
    padding: 15px 20px;
    color: white;
    &:before
      content: "";
      position: absolute;
      top: 20px;
      left: -30px;
      z-index: 1;
      border: solid 15px transparent;
      border-right-color: #283248;

  .ok-button
    font-weight: bold;
    align-self: flex-end;
    margin-top: 20px;

  .ok-button:hover
    cursor: pointer;
    cursor: hand;
</style>



// WEBPACK FOOTER //
// onboardingSteps.vue?429617bc